// extracted by mini-css-extract-plugin
export default {"UserDropdown":"_UserDropdown--XGUUT","UserButton":"_UserButton--XhTNF","UserButtonIcon":"_UserButtonIcon--X09X0","Tooltip":"_Tooltip--nWAJu"};